import { render, staticRenderFns } from "./segmento.vue?vue&type=template&id=f36f9090"
import script from "./segmento.vue?vue&type=script&lang=js"
export * from "./segmento.vue?vue&type=script&lang=js"
import style0 from "./segmento.vue?vue&type=style&index=0&id=f36f9090&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports